import { PopupPanel, DropDownSelector } from 'component/popup';
import { UtilityText } from 'component/text';
import { component, demoFile } from 'system/demo';

demoFile('component/popup');

function PopupPanelDemo() {
  return (
    <PopupPanel popupContent={() => <UtilityText text='Popup content' />}>
      <UtilityText text='Open Popup' />
    </PopupPanel>
  );
}

component('PopupPanel', PopupPanelDemo);

component('DropDownSelector', DropDownSelector, {
    args: {
        text: 'Sort',
        options: [{key:'a', label:'!A'}, {key:'b', label:'!B'}],
        value: 'a',
        onChange: () => {}
    }
});
